import {PaymentType} from "../constants/PaymentType";
import {LicenseType} from "../../institution/detail/license/constants/LicenseType";

export class PaymentDto {
    public seq: number = 0;
    public paymentsNumber: string = "";
    public price: number = 0;
    public userName: string = "";
    public email: string = "";
    public status: number = PaymentType.WAITING;
    public paidAt: string = "";
    public content: string = "";
    public isLicense: boolean = false;
}

export class DetailDto {
    public licenseType: LicenseType = LicenseType.CONTROL_SYSTEM;
    public lectureName: string = "";
    public thumbnailUrl: string = "";
    public price: number = 0;
    public bank: string = "";
    public cardNumber: string = "";
    public accountNumber: string = "";
    public status: number = PaymentType.WAITING;
    public paidAt: string = "";
    public refundAt: string = "";
    public refundPrice: number = 0;
    public reason: string = "";
}